import { StringFormat, formatString } from 'src/utils/format-string';

export const formatVariableName = (variable: string): string => {
    return formatString(variable, StringFormat.SnakeCase, StringFormat.SentenceCase);
};

/**
 * Convert a suspected variable name into a valid variable name string.
 */
export const coerceVariableName = (s: string): string => {
    return s.toLowerCase().trim().replace(/\s+/g, '_');
};

/**
 * Return the variables that the message contains.
 * Variables will be returned in the order in which they occur in the text.
 *
 * Rules for variables
 *  - vars will always have at least length 1.
 *  - vars will never have leading/trailing spaces.
 *  - vars will always be properly formatted (no spaces, no caps, underscores only)
 *
 * NOTE: these may not necessarily be valid/known variables. Get those from the backend.
 */
export const getVariablesFromMessage = (message?: string): string[] => {
    const variablePattern = /\{(.*?)\}/g;
    const matches = message?.matchAll(variablePattern);
    if (!matches) { return []; }
    const foundVars = [];
    for (const match of matches) {
        // match[0] is the full match while match[1] is the group
        const varNameRaw = match[1].trim();
        if (varNameRaw !== '') {
            const varName = coerceVariableName(varNameRaw);
            foundVars.push(varName);
        }
    }

    return foundVars;
};

export const formatPlaybookMessageForBackend = (content: string): string => {
    return content.replace(/{(.*?)}/g, (_, match) => `{${match.toLowerCase().replace(/ /g, '_')}}`);
};

export const formatPlaybookMessageForFrontend = (content: string): string => {
    return content.replace(/{(.*?)}/g, (_, match) => `{${formatVariableName(match)}}`);
};